export default {
      id: "linkedin-negative-usage",
      viewBox: "0 0 512 512",
      url: "/assets/svg/" + "sprite.svg#linkedin-negative-usage",
      toString: function () {
        return this.url;
      }
    }